import { AccessMode, AccessItem } from 'app/components/access-panel/shared/types';

export const serializeDefaultValues = (item: AccessItem) => {

  if (!item || item.mode === AccessMode.role || !item.customData || !item.customData.values) {
    return [];
  }

  const values = item.customData.values;

  return values.reduce((memo, value) => [
    ...memo,
    ...value.defaultValueFields.map(field => (
      {
        codeTable: { v: value.optionsColection.value },
        caseType: { v: value.caseType.value },
        defaultValue: { v: value.defaultValue.value },
        field: { v: field.value }
      }))
  ], []);
};
